import * as React from 'react';
import { FormWidget } from '@cian/frontend-request-form-widget';

import { useRequestForm } from './utils/useRequestForm';
import { PrevQuestionButton } from '../../components/PrevQuestionButton';
import { EInputType } from '../../types/requestFormSchema';
import { MultipleFilesUploadContainer, SingleFilesUploadContainer } from '../FilesUploadContainer';
import { FIOSuggestFieldContainer } from '../FIOSuggestFieldContainer';
import { PhoneFieldContainer } from '../PhoneFieldContainer';
import { AddressCadastreFieldContainer, DefaultInputModeContextProvider } from '../AddressCadastreFieldContainer';
import { QuestionLayoutContainer } from '../QuestionLayoutContainer';
import { IRequestFormValue } from '../../types/requestFormValue';
import { IRequestFormQuestion } from '../../types/requestForm';

export const RequestFormContainer: React.FC = () => {
  const {
    stepsSchema,
    firstStepCode,
    skipSteps,
    initialFormValue,
    initialStepCode,
    defaultInputMode,
    handleSubmit,
    handleNext,
    handlePrev,
  } = useRequestForm();

  return (
    <DefaultInputModeContextProvider value={defaultInputMode}>
      <FormWidget<IRequestFormValue, IRequestFormQuestion>
        stepsSchema={stepsSchema}
        firstStepCode={firstStepCode}
        skipSteps={skipSteps}
        initialFormValue={initialFormValue}
        initialStepCode={initialStepCode}
        components={{
          ReturnButtonComponent: PrevQuestionButton,
          QuestionLayoutComponent: QuestionLayoutContainer,
        }}
        fieldMapperExtension={{
          [EInputType.MultipleFiles]: MultipleFilesUploadContainer,
          [EInputType.File]: SingleFilesUploadContainer,
          [EInputType.FullName]: FIOSuggestFieldContainer,
          [EInputType.Phone]: PhoneFieldContainer,
          [EInputType.AddressCadastre]: AddressCadastreFieldContainer,
        }}
        onSubmit={handleSubmit}
        onNextStep={handleNext}
        onPrevStep={handlePrev}
      />
    </DefaultInputModeContextProvider>
  );
};
